import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_3M_66_65_3M_24_99_EN_CLUSTER',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_3m_66_65_3m_24_99_usd',
			GBP: 'simple_premium_3m_66_65_3m_25_99_gbp',
			CAD: 'simple_premium_3m_99_99_3m_31_99_cad',
			AUD: 'simple_premium_3m_99_99_3m_39_99_aud',
		},
		primer: 'prd_HndF7PHyRaOI',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 24.99,
			GBP: 25.99,
			CAD: 31.99,
			AUD: 39.99,
		},
		originalPriceMap: {
			USD: 66.65,
			GBP: 66.65,
			CAD: 99.99,
			AUD: 99.99,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 66.65,
			GBP: 66.65,
			CAD: 99.99,
			AUD: 99.99,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.90_days.into_period_text'), // 'first quarter'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.90_days.sub_period_text'), // 'quarterly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.90_days.into_period_text'), // 'three months'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.90_days.period_text'), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.90_days.sub_period_text'), // '3-month'
	}),
}
